import { TreeDotsIcon } from "components/ui/icons/threeDots/ThreeDots"
import style from "./ButtonOptions.module.scss"

const { buttonOptions } = style

type Props = {
	className?: string
	style?: React.CSSProperties
	fillColor?: string
}

export const ButtonOptions = ({ className = "", style = {}, fillColor }: Props) => {
	return (
		<button className={`${className} ${buttonOptions}`} style={style} data-testid="button-options">
			<TreeDotsIcon fillColor={fillColor} />
		</button>
	)
}
